import React from 'react';
import {
  SinglePageHeader,
  FooterWithoutAuth,
  BlogCard,
  Layout,
} from 'components';
import './packages-and-payment-page.less';

import './blog.less';
import marketingImg from '../../assests/images/iys.png';
import blogBannerAccessory1 from '../../assests/images/pap-accessory-1.png';
import blogBannerAccessory2 from '../../assests/images/features-accessory-3.png';
import { LANDING_MENU } from 'constants/page.const';
import MetaTags from 'react-meta-tags';

const IYSPage = () => {
  return (
    <Layout
      hamburgerMenuWithButton={true}
      hamburgerMenuData={LANDING_MENU}
      hamburgerMenuClass="single-page-v1"
      withoutHeaderDropdown={true}
      withoutCreditInfo={true}
      menuSinglePageV2={true}
      customMenuRender={() => <SinglePageHeader />}
    >
      <MetaTags>
        <title>
        İleti Yönetim Sistemi (İYS) Nedir? - Mesaj Üssü
        </title>
        <meta
          name="description"
          content="İYS Nedir? İleti yönetim sistemine kayıt yapmak zorunlu mu? İYS başvuru nasıl yapılır? İYS hakkında merak ettiklerinizi bu yazımızda bulabilirsiniz."
        />
         <link rel="canonical" href="https://mesajussu.turkcell.com.tr/iys-nedir" />
      </MetaTags>
      <div className="blog-page blog-page--marketing">
        <div className="blog-banner">
          <div className="container">
            <div>
              <h1 className="section__title--big">
              İleti Yönetim Sistemi (İYS) Nedir?
              </h1>
              <p className="info-text--big">
              İYS Nedir? İleti yönetim sistemine kayıt yapmak zorunlu mu? İYS başvuru nasıl yapılır? İYS hakkında merak ettiklerinizi bu yazımızda bulabilirsiniz.
              </p>
            </div>
            <figure>
            <a href="/toplu-sms">
              <img src={marketingImg} alt="İleti Yönetim Sistemi (İYS) Nedir? - Mesaj Üssü"/>
            </a> 
            </figure>
          </div>
          <img
            id="blog-banner-accessory-1"
            src={blogBannerAccessory1}
            alt="İleti Yönetim Sistemi (İYS) Nedir? - Mesaj Üssü 2"
          />
          <img
            id="blog-banner-accessory-2"
            src={blogBannerAccessory2}
            alt="İleti Yönetim Sistemi (İYS) Nedir? - Mesaj Üssü 3"
          />
        </div>
        <div className="blogs-wrapper">
          <div className="container">
            <ul>
              <li>
              Elektronik Ticaretin Düzenlenmesi Hakkında Kanun ve Ticari İletişim ve Ticari Elektronik İletiler Hakkında Yönetmelik uyarınca etkin hale getirilen İleti Yönetim Sistemi (İYS), çift yönlü işleyen ve hizmet sağlayıcılar ile alıcıların farklı kazanımlar elde etmelerini sağlayan bir veri tabanı sistemdir. İleti Yönetim Sistemi (İYS), hizmet sağlayıcıların veya şirketlerin ticari elektronik mesaj gönderilmesi için bireylerden aldıkları izni kontrol edebilmesine, aynı zamanda onay ve ret hakkını yönetebilmesini sağlayan bir platformdur. İleti Yönetim Sistemi tüketiciler açısından, ticari elektronik mesaj alıp almak istemediklerini hizmet sağlayıcılarını belirtebilecekleri bir sistemdir. Buna aramalar, e-postalar ve SMS’ler de dahildir. İleti Yönetim Sistemi’ne SMS’ler de dahil olduğu için bu durum toplu SMS yoluyla hedef kitleleriyle iletişime geçen şirketleri de etkilemektedir. Nitekim yapılan yeni yasal düzenleme ile birlikte hizmet sağlayıcılar için İleti Yönetim Sistemi’ne izinli veri tabanının yüklenmesi zorunlu hale gelmiştir. Bu yüzden İleti Yönetim Sistemi’ne kayıt ve sürecin sağlıklı bir şekilde yönetilmesi hedef kitleleri ile toplu SMS yoluyla iletişime geçen şirketler için son derece önemlidir. İYS hakkında detaylı bilgi almak isteyenler İleti Yönetim Sistemi hakkında sıkça sorulan soruları ve kayıt olma adımlarına aşağıdan ulaşabilirsiniz.
              </li>
              <li>
                <h2>Hizmet Sağlayıcı Kimdir?</h2>
                <p>
                Hizmet sağlayıcı, ticari elektronik ileti gönderimi gerçekleştiren gerçek ve tüzel kişiler olarak tanımlanır. Hizmet sağlayıcıların, alıcılar tarafından verilen izinleri sistem üzerinden takip ederek saklama ve yönetme imkanları vardır.
                </p>
              </li>
              <li>
                <h2>Alıcı Kimdir?</h2>
                <p>
                Hizmetler hakkında SMS, e-posta ve telefon aracılığıyla bildirim alan vatandaşlar ise ileti yönetim sistemi yönetmeliği için hazırlanan mevzuatta alıcılar olarak ifade edilir.
                </p>
              </li>
              <li>
                <h2>İYS Kaydı Yapmak Zorunlu mu?</h2>
                <p>
                Ticaret Bakanlığı bu sistemi uygulamaya koyarak, ticari elektronik ileti gönderimi gerçekleştiren tüm hizmet sağlayıcılara İYS kayıt yükümlülüğü getirmektedir. İleti gönderimi işlemlerine aksamadan devam edilebilmesi için, İleti Yönetim Sistemi son başvuru tarihi olan 31 Mayıs 2021 tarihine kadar sisteme kayıt olma zorunluluğu vardır. İYS 16 Temmuz 2021’de aktif hale geldiğinde, onaylayan alıcılara ticari elektronik ileti göndermeye devam edilebilecektir. Sistem kaydı bulunmayan hizmet sağlayıcılar, ticari elektronik ileti gönderimi gerçekleştiremeyecektir. Ayrıca onay vermeyen ya da red hakkını kullanan vatandaşlara da belirtilen iletilerin gönderimi yapılmayacaktır. Bu yüzden ticari iletiler gönderen firmalar için İYS yönetmelik detayları oldukça önemlidir.
                </p>
              </li>
              <li>
                <h2>
                İleti Yönetim Sistemi Onayına Tabi Olmayan Durumlar Nelerdir?
                </h2>
                <p>
                Kanunda bazı istisnai haller, İYS onayı dışında bırakılmıştır:

Alıcının iletişim bilgilerini, iletişime geçilmesi amacıyla vermesi durumunda, söz konusu olan mal veya hizmetlere ilişkin bakım, kullanım ve değişikliklere yönelik ticari elektronik iletilerde onaya ihtiyaç duyulmaz.
Tacir ve esnaflara, onaya gerek duyulmadan ticari elektronik iletiler gönderilebilir.
Kanun kapsamında yer alan ve bilgi verme yükümlülüğü bulunan durumlarda, onay alınmaksızın zorunlu bilgilendirmeler için ileti gönderimi gerçekleştirilir.
                </p>
               
              </li>
              <li>
                <h3>
                Ticari İşletmeler İçin İYS Kaydı Nasıl Gerçekleştirilir?
                </h3>
                <p>
                İleti Yönetim Sistemi’ne kayıt işlemlerinin gerçekleştirilebilmesi için, belirli aşamalar takip edilmelidir. İYS başvuru süreci için aşağıdaki adımları takip edebilirsiniz:


                </p>
                <ul>
                  <ul>
                    <li>
                    İlk olarak <a target='_blank' href='https://iys.org.tr/'></a> adresinden sisteme kaydolarak giriş yapılır. Başvuruyu yalnızca MERSİS kaydı bulunan veya bu kayda yetkili bulunan kişiler gerçekleştirebilir. MERSİS kaydınız mevcut ve bilgileriniz güncel durumdaysa, hızlı giriş yapabilmek adına e-devlet ile giriş seçeneğini kullanabilirsiniz.
                    </li>
                  </ul>
                </ul>
                <br />
                <img
                  src="/assets/images/iys/1.png"
                  alt=""
                  className="content-image"
                />
                <br />
                <ul>
                  <ul>
                    <li>
                      Ardından &ccedil;ıkan ekran &uuml;zerinden
                      &lsquo;&rsquo;e-devlet girişi&rsquo;&rsquo; butonuna
                      tıklamalısınız.
                    </li>
                  </ul>
                </ul>
                <br />
                <img
                  src="/assets/images/iys/2.png"
                  alt=""
                  className="content-image"
                />
                <br />
                <ul>
                  <ul>
                    <li>
                      Ardından giriş sayfasında kimlik bilgilerinizi girmeli ve
                      kimliğinizi doğrulamalısınız.
                    </li>
                  </ul>
                </ul>
                <br />
                <img
                  src="/assets/images/iys/3.png"
                  alt=""
                  className="content-image"
                />
                <br />
                <ul>
                  <ul>
                    <li>
                      Giriş işlemini ger&ccedil;ekleştirdiğinizde, karşınıza
                      &ccedil;ıkan ekranda&ldquo; Hizmet Sağlayıcılar
                      İ&ccedil;in Başvuru Formu&rdquo;nu g&ouml;receksiniz. Bu
                      ekran &uuml;zerinden &ouml;nce kurumsal e-mail adresi
                      girmelisiniz.. &lsquo;&rsquo;G&uuml;venlik
                      kodu&rsquo;&rsquo; alanında beliren kodu ise boş alana
                      girmeli ve &lsquo;&rsquo;Doğrula&rsquo;&rsquo; butonuna
                      basmalısınız. Ardından sistem tarafından belirttiğiniz
                      kurumsal e-posta adresinize doğrulama kodu
                      g&ouml;nderilir.
                    </li>
                  </ul>
                </ul>
                <br />
                <img
                  src="/assets/images/iys/4.png"
                  alt=""
                  className="content-image"
                />
                <br />
                <ul>
                  <ul>
                    <li>
                      Ardından belirttiğiniz e-posta adresinize gelen kod ile
                      e-posta doğrulama işlemini yapmalısınız. Bu doğrultuda
                      kurumsal e-posta adresinize gelen doğrulama kodunu aşağıda
                      yer alan g&ouml;rseldeki &lsquo;&rsquo;Doğrulama
                      kodu&rsquo;&rsquo; alanına girmeli ve
                      &lsquo;&rsquo;Başvuruyu başlat&rsquo;&rsquo; butonuna
                      tıklamalısınız. B&ouml;ylelikle e-posta doğrulama
                      s&uuml;reci de tamamlanmış olacak.
                    </li>
                  </ul>
                </ul>
                <br />
                <img
                  src="/assets/images/iys/5.png"
                  alt=""
                  className="content-image"
                />
                <br />
                <ul>
                  <ul>
                    <li>
                      Ardından telefon numarası doğrulama işlemini yapmalısınız.
                      Bunun i&ccedil;in aşağıdaki g&ouml;rselde de yer alan
                      ekranda &lsquo;&rsquo;Cep telefonu numaranız&rsquo;&rsquo;
                      alanına yetkili kişinin cep telefonu numarasını girmeli ve
                      &lsquo;&rsquo;Doğrulama kodu g&ouml;nder&rsquo;&rsquo;
                      butonuna tıklamalısınız. Bu butona tıkladıktan hemen sonra
                      ilgili numaraya bir doğrulama kodu gelir.
                    </li>
                  </ul>
                </ul>
                <br />
                <img
                  src="/assets/images/iys/6.png"
                  alt=""
                  className="content-image"
                />
                <br />
                <ul>
                  <ul>
                    <li>
                      Karşınıza &ccedil;ıkan ekrana cep telefonuna gelen kodu
                      girmeli ve onaylamalısınız. B&ouml;ylelikle cep telefonu
                      numarası onaylama işlemi de tamamlanmış olacaktır.
                    </li>
                  </ul>
                </ul>
                <br />
                <img
                  src="/assets/images/iys/7.png"
                  alt=""
                  className="content-image"
                />
                <br />
                <ul>
                  <ul>
                    <li>
                      İYS sisteminde doğrulama işleminin tamamlanmasının
                      ardından aynı form &uuml;zerinden MERSİS numaranızı
                      eksiksiz ve doğru bir şekilde belirtilen kısma girmeniz
                      gerekir. Bu işlem sonrasında sorgulama butonuna basarak
                      bilgilerinizin MERSİS aracılığı ile sonraki adıma
                      aktarılmasını sağlayabilirsiniz. Sorgulama işlemi ile
                      sisteme tanımlanan TCKN&rsquo;nin hizmet sağlayıcıya ait
                      olup olmadığı kontrol edilmiş olunur.
                    </li>
                  </ul>
                </ul>
                <br />
                <img
                  src="/assets/images/iys/8.png"
                  alt=""
                  className="content-image"
                />
                <br />
                <ul>
                  <ul>
                    <li>
                      Sonraki adımda karşınıza b&uuml;y&uuml;k bir
                      b&ouml;l&uuml;m&uuml; otomatik olarak doldurulmuş olan
                      form gelecektir. Bu alanda o ana kadar doldurduğunuz
                      bilgilerin t&uuml;m&uuml; yer almaktadır. Eksik kalan
                      kısımları da kendiniz doldurarak bu formla s&ouml;zleşmeyi
                      onayladığınıza dair kutucuğu işaretlemeniz gerekir. Bu
                      aşamadan sonra bu kez taahh&uuml;tname sayfası karşınıza
                      &ccedil;ıkar. Bilgileri okuyup, sayfanın en altında yer
                      alan kutucuğu işaretleyerek taahh&uuml;tname onayını
                      yapabilirsiniz. Ardından &lsquo;&rsquo;Sonraki
                      adım&rsquo;&rsquo; butonuna tıklamalısınız.
                    </li>
                  </ul>
                </ul>
                <br />
                <img
                  src="/assets/images/iys/9.png"
                  alt=""
                  className="content-image"
                />
                <br />
                <ul>
                  <ul>
                    <li>
                      Yeni a&ccedil;ılan ekranda kullanım taahh&uuml;tnamesi
                      karşınıza &ccedil;ıkacaktır. Bu alanda kullanım
                      taahh&uuml;tnamesini okumalı ve onaylamalısınız. Ardından
                      &lsquo;&rsquo;Sonraki adım&rsquo;&rsquo; butonuna
                      tıklayarak bir sonraki aşamaya ge&ccedil;melisiniz.
                    </li>
                  </ul>
                </ul>
                <br />
                <img
                  src="/assets/images/iys/10.png"
                  alt=""
                  className="content-image"
                />
                <br />
                <ul>
                  <li>
                    Aşağıda yer alan g&ouml;rselde de g&ouml;rebileceğiniz
                    ekranda marka ekleme işlemini yapmalısınız. Bu alanda hizmet
                    sağlayıcı &uuml;zerine tescil edilen marka bilgilerini
                    girmeli ve &lsquo;&rsquo;Kaydet&rsquo;&rsquo; butonuna
                    tıklamalısınız. Ardından a&ccedil;ılan ekranda dilediğiniz
                    kadar yeni marka ekleyebilirsiniz. Tescilli markanız
                    bulunmuyorsa ya da ticari unvanınız ile iletişim
                    yapıyorsanız firmanızın ticari unvanını yazabilir ve
                    herhangi bir belge eklemeye gerek kalmadan başvurunuzu
                    tamamlayabilirsiniz.
                  </li>
                </ul>
                <p>
                  <br />
                  <strong>NOT: </strong>Firma unvanı haricinde bir marka
                  bulunuyorsa marka adını yazarak marka tescil belgesini
                  eklemelisiniz. Bu durumda dikkat etmeniz gereken belli başlı
                  hususlar bulunmaktadır.
                </p>
                <ul>
                  <ul>
                    <li>
                      T&uuml;rk Patent Kurumu tarafından tescillenen marka adı
                      tam olarak belirtilmelidir.
                    </li>
                    <li>
                      İYS&rsquo;ye kayıt olan hizmet sağlayıcı markanın sahibi
                      olarak g&ouml;r&uuml;nmelidir. Bu koşul sağlanamıyorsa
                      marka sahibi ile başvuru yapan hizmet sağlayıcı arasında
                      markanın kullanım hakkını g&ouml;steren bir belge, marka
                      tescil belgesi ile birlikte y&uuml;klenmelidir.
                    </li>
                    <li>
                      C. T&uuml;rk Patent ve Marka Kurumu tarafından verilen
                      marka tescil belgesinin y&uuml;klenmesi zorunludur.
                    </li>
                    <li>
                      Şeklen farklı olan ama aynı adla tescillenen marka
                      onaylarında, marka adına farklı yazı karakteri ve
                      şekillerde alınmış tescil belgeleri tek PDF haline
                      getirilmeli ve bir marka adı altında y&uuml;klenmelidir.
                    </li>
                  </ul>
                </ul>
                <br />
                <img
                  src="/assets/images/iys/11.png"
                  alt=""
                  className="content-image"
                />
                <br />
                <ul>
                  <ul>
                    <li>
                      S&ouml;z konusu işlemlerden sonra ticari işletmeniz
                      i&ccedil;in İYS kaydında son aşamaya ge&ccedil;miş
                      olursunuz. Son aşamada karşınıza &ccedil;ıkan ekranda daha
                      &ouml;nce verdiğiniz bilgilerin bir &ouml;zeti yer
                      almaktadır. &Ouml;nce bu bilgilerin doğruluğunu kontrol
                      etmeli ardından ise &lsquo;&rsquo;Verdiğim t&uuml;m
                      bilgilerin/belgelerin doğruluğunu beyan
                      ederim&rsquo;&rsquo; kutucuğuna tıklayarak
                      onaylamalısınız.
                    </li>
                  </ul>
                </ul>
                <br />
                <img
                  src="/assets/images/iys/12.png"
                  alt=""
                  className="content-image"
                />
                <br />
                <p>
                  T&uuml;m adımları tamamlamanızın ardından başvuru işleminiz
                  ger&ccedil;ekleşmiş olur. Ayrıca başvuru numaranız da bu
                  ekranda yer alır. Başvuru numaranızı mutlaka saklamalısınız.
                  Yapılan incelemelerin ardından sizinle e-posta adresiniz ve
                  telefon numaranız &uuml;zerinden bilgilendirme ama&ccedil;lı
                  iletişime ge&ccedil;ilecektir.
                </p>
              </li>
              <li>
                <h3>
                  Ticari Ama&ccedil;larla G&ouml;nderilen SMS&rsquo;lerde Nelere
                  Dikkat Edilmelidir?
                </h3>
                <p>
                  Ticari elektronik ileti g&ouml;nderiminin İYS şartlarına
                  uyumlu olabilmesi i&ccedil;in, alıcıdan alınan onayın doğru
                  tahlil edilmesi gerekir. Burada alıcı onayı mesaj, arama ya da
                  e-posta işlemlerinin hepsinde ya da yalnızca birinde olabilir.
                  &Ouml;ncelikle buna dikkat edildikten sonra, aşağıda
                  belirtilen hususların mesaj i&ccedil;eriklerinde yer almasına
                  dikkat edilmelidir. Mesaj i&ccedil;eriğinde:
                </p>
                <ul>
                  <li>
                    Esnaflar i&ccedil;in ad, soyad ve T.C Kimlik Numarası
                    bilgileri yer almalı.
                  </li>
                  <li>
                    Tacirler MERSİS numaralarını ve Ticaret Unvanlarını
                    belirtmeli.
                  </li>
                  <li>
                    Hizmet sağlayıcılara ait telefon, faks, e-posta gibi
                    iletişim bilgilerinden en az biri mesajda yer almalı.
                  </li>
                  <li>
                    0800&rsquo;l&uuml; hat iletilerinde, ayrıca SMS red işlem
                    bildirimi i&ccedil;in iletişim numarası bulunmalı.
                  </li>
                  <li>
                    Kanunda tanımlanan bilgi verme
                    y&uuml;k&uuml;ml&uuml;l&uuml;kleri kapsamında mesajlar
                    a&ccedil;ık&ccedil;a anlaşılır olmalı. Tanıtım, kampanya,
                    indirim, promosyon, hediye gibi bilgilendirici detaylar
                    mesaj i&ccedil;erisinde a&ccedil;ık şekilde belirtilmelidir.
                  </li>
                </ul>
              </li>
              <li>
                <h2>
                  İYS&rsquo;de İzinli Veri Tabanı Nasıl Y&uuml;klenir ve Nasıl
                  Y&ouml;netilir?
                </h2>
                Halihazırda izinli olarak SMS g&ouml;nderdiğiniz hedef kitleniz
                &uuml;zerinden izinli veri tabanı oluşturmanız gerekmektedir. Bu
                işlemi İYS &uuml;zerinden yapabilirsiniz. Bunun i&ccedil;in ilk
                aşamada eğer hen&uuml;z İYS kaydını tamamlamadıysanız,
                İYS&rsquo;ye kayıt olmalısınız. Yeni d&uuml;zende İYS&rsquo;ye
                kaydolduktan sonra izinli veri tabanınızı oluşturabilirsiniz.
                İzinli veri tabanınızı oluşturduktan sonra s&uuml;reci
                y&ouml;netmeye başlayabilirsiniz.
                <br />
                <br />
                İzinli veri tabanının y&uuml;klenmesi ve y&ouml;netimi ile
                ilgili detaylı bilgiler ise aşağıdaki gibi sıralanabilir:
                <ul>
                  <ul>
                    <li>
                      İlk aşamada e-devlet &uuml;zerinden &lsquo;&rsquo;Hizmet
                      Sağlayıcılar&rsquo;&rsquo; i&ccedil;in belirtilen alan
                      &uuml;zerinden giriş yapmalısınız.
                    </li>
                  </ul>
                </ul>
                <br />
                <img
                  src="/assets/images/iys/13.png"
                  alt=""
                  className="content-image"
                />
                <br />
                <ul>
                  <ul>
                    <li>
                      E-devlet sistemine giriş yaptıktan sonra karşınıza aşağıda
                      yer alan g&ouml;rseldeki gibi bir ekran &ccedil;ıkacaktır.
                      Bu alanda İYS veri girişi yapmak istediğiniz markanızın
                      se&ccedil;imini yapmalısınız.
                    </li>
                  </ul>
                </ul>
                <br />
                <img
                  src="/assets/images/iys/14.png"
                  alt=""
                  className="content-image"
                />
                <br />
                <ul>
                  <ul>
                    <li>
                      Marka se&ccedil;iminizi yaptıktan sonra izin eklemeye
                      başlamadan &ouml;nce alıcı tipini girmelisiniz. Bu alanda
                      aşağıdaki g&ouml;rselde de belirtildiği &uuml;zere aynı
                      iletişim adresi i&ccedil;in bir bireysel, bir tacir izin
                      kaydı oluşturabilirsiniz. Diğer bir deyişle, aynı iletişim
                      adresi &uuml;zerinden hem tacir hem de bireysel alıcı
                      olarak İYS kaydı yapabilirsiniz.
                    </li>
                  </ul>
                </ul>
                <br />
                <img
                  src="/assets/images/iys/15.png"
                  alt=""
                  className="content-image"
                />
                <br />
                <ul>
                  <ul>
                    <li>
                      Bu işlemin ardından karşınıza aşağıda yer alan
                      g&ouml;rseldeki gibi bir ekran &ccedil;ıkacaktır. Bu
                      alanda sırasıyla izin t&uuml;r&uuml; se&ccedil;imi,
                      ge&ccedil;erli alıcı bilgisi,
                      &lsquo;&rsquo;Onay&rsquo;&rsquo; kutucuğunun
                      se&ccedil;imi, izin kaynağına ilişkin detayın
                      se&ccedil;imi, tarih ve saat se&ccedil;imi işlemleri
                      yapılmalıdır.
                    </li>
                  </ul>
                </ul>
                <br />
                <img
                  src="/assets/images/iys/16.png"
                  alt=""
                  className="content-image"
                />
                <br />
                <ul>
                  <ul>
                    <li>
                      S&ouml;z konusu işlemlerin ardından s&uuml;re&ccedil;
                      tamamlanmış olur. S&uuml;recin daha iyi anlaşılması adına
                      aşağıdaki g&ouml;rselde bir telefon numarasına ait onay
                      kaydı &ouml;rneğini inceleyebilirsiniz.
                    </li>
                  </ul>
                </ul>
                <br />
                <img
                  src="/assets/images/iys/17.png"
                  alt=""
                  className="content-image"
                />
                <br />
                <ul>
                  <ul>
                    <li>
                      Aşağıdaki g&ouml;rselde bir e-posta adresine ait onay
                      kaydı &ouml;rneğini inceleyebilirsiniz.
                    </li>
                  </ul>
                </ul>
                <br />
                <img
                  src="/assets/images/iys/18.png"
                  alt=""
                  className="content-image"
                />
              </li>
              <li>
                <h2>
                  Aracı Hizmet Sağlayıcı (AHS) Nedir?
                  Y&uuml;k&uuml;ml&uuml;l&uuml;kleri Nelerdir?
                </h2>
                Aracı hizmet sağlayıcı kısaca bir ticari elektronik iletinin
                alıcıya g&ouml;nderilmeden &ouml;nce izin kontrol&uuml;n&uuml;
                yapmakla y&uuml;k&uuml;ml&uuml; firma olarak tanımlanabilir.
                Toplu mesaj g&ouml;nderimlerinde alıcı, iş ortağı, kamu ve
                hizmet sağlayıcılar arasındaki ilişkinin &ouml;nemli
                &ouml;ğeleri arasında yer almaktadır.
                <br /> Aracı hizmet sağlayıcı y&uuml;k&uuml;ml&uuml;l&uuml;kleri
                ise aşağıdaki gibi sıralanabilir:
                <br />
                <img
                  src="/assets/images/iys/19.png"
                  alt=""
                  className="content-image"
                />{' '}
                <br />
                <ul>
                  <li>
                    Hizmet sağlayıcı i&ccedil;in &ouml;ng&ouml;r&uuml;len
                    y&uuml;k&uuml;ml&uuml;l&uuml;klerin ifasına y&ouml;nelik
                    teknik olanaklar sağlar.
                  </li>
                  <li>
                    Ticari elektronik ileti g&ouml;nderimine ilişkin sistemini
                    İYS ile uyumu hale getirir.
                  </li>
                  <li>
                    İleti y&ouml;netim sistemi (İYS) kaydını hen&uuml;z yapmayan
                    hizmet sağlayıcılar i&ccedil;in ticari elektronik iletilerin
                    g&ouml;nderimlerini başlatmaz.
                  </li>
                  <li>
                    Hizmet sağlayıcıların ileti g&ouml;nderimine başlamadan
                    &ouml;nce ileti y&ouml;netim sistemi (İYS) &uuml;zerinden
                    alıcıların onayının olup olmadığına dair kontrolleri sağlar
                    ve kontrol neticesinde onayı olmayan alıcılara ileti
                    g&ouml;nderimini başlatmaz.
                  </li>
                  <li>
                    Alıcıların abonelik hattını kapatmaları durumunda
                    İYS&rsquo;ye durumu bildirir.
                  </li>
                </ul>
                <p>
                  <br />
                  Sonu&ccedil; olarak İYS web &uuml;zerinden aracı hizmet
                  sağlayıcı yetkilendirilmesinin yapılmadığı durumunda ticari
                  elektronik ileti g&ouml;nderimi yapılamayacaktır. Bu
                  y&uuml;zden aracı hizmet sağlayıcı izni verilmelidir.
                </p>
              </li>
              <li>
                <h3>Aracı Hizmet Sağlayıcı İzni Nasıl Verilir?</h3>
                <p>
                  İYS iş ortakları hizmet sağlayıcıların yetkilendirmesi ile
                  firmalar adına ticari elektronik ileti g&ouml;nderimi
                  ger&ccedil;ekleştirebilir. İYS web sitesi &uuml;zerinden kayıt
                  işlemlerinizi tamamladıktan sonra, kurumsal giriş yaparak iş
                  ortağı yetkilendirme işlemlerinizi
                  ger&ccedil;ekleştirebilirsiniz. Bu aşama hizmet sağlayıcılara,
                  birden &ccedil;ok iş ortağı yetkilendirme hakkı tanınmaktadır.
                  Yetkilendirme, veriye erişim ve iletişim kapsamında
                  ger&ccedil;ekleştirilebilir. Bu yolla iş ortağı, hizmet
                  sağlayıcı adına arama, mesaj ve e-posta g&ouml;nderimi gibi
                  işlemleri ve mutabakat servisi işlemlerini
                  y&uuml;r&uuml;tebilir. Bunlarda mutabakat servisi işlemlerinde
                  birden fazla iş ortağı yetkilendirmesi yapılamaz. Mutabakat
                  servisi i&ccedil;in yalnızca bir tek iş ortağı
                  yetkilendirilebilir.
                  <br />
                  <br />
                  Aracı hizmet sağlayıcı ile ilgili genel bir bilgi verdikten
                  sonra tanımlamaların nasıl yapılacağına dair detaylara
                  değinebiliriz. E-devlet &uuml;zerinden aracı hizmet sağlayıcı
                  (AHS) tanımlamasını birka&ccedil; adımda hızlı ve kolay bir
                  şekilde yapabilirsiniz. Bunun i&ccedil;in aşağıdaki adımlarını
                  takip etmeniz yeterlidir:
                </p>
                <ul>
                  <ul>
                    <li>İlk aşamada e-devlet hesabınıza giriş yapmalısınız.</li>
                    <li>
                      E-devlet hesabınıza girdikten sonra karşınıza aşağıdaki
                      gibi bir ekran &ccedil;ıkmaktadır. Bu ekranda sol
                      men&uuml;de yer alan &lsquo;&rsquo;Marka
                      Y&ouml;netimi&rsquo;&rsquo; sekmesine girmelisiniz.
                    </li>
                  </ul>
                </ul>
                <br />
                <img
                  src="/assets/images/iys/20.png"
                  alt=""
                  className="content-image"
                />
                <br />
                <ul>
                  <ul>
                    <li>
                      Marka y&ouml;netimi sekmesinde hem daha &ouml;nce
                      tanımladığınız aracı hizmet sağlayacılarını g&ouml;rebilir
                      ve bunları y&ouml;netebilir hem de AHS i&ccedil;in yeni
                      tanımlamalar yapabilirsiniz.
                    </li>
                  </ul>
                </ul>
                <br />
                <img
                  src="/assets/images/iys/21.png"
                  alt=""
                  className="content-image"
                />
              </li>
              <li>
                <h3>
                  Tanımlı İYS Marka Bilgisi Mesaj Üssü ile Nasıl Eşleştirilir?
                </h3>
                İleti Y&ouml;netim Sistemi&rsquo;ne kayıt olduktan sonra size
                bir ID numarası gelmektedir. Size verilen ID numarasını Mesaj
                Üssü ile eşleştirmeniz gerekmektedir. Mesaj Üssü&rsquo;nden yeni
                hizmet almaya başlayacak firmalar i&ccedil;in tanımlı mesaj
                başlığı olması gerekmektedir. Bu eşleştirmeleri g&ouml;nderi
                ekranlarında ya da yeni mesaj başlığı tanımlarken
                ger&ccedil;ekleştirebilirsiniz. ID bilgisinin Mesaj
                Üssü&rsquo;nde tanımlı olmadığı ve SMS atıldığı durumlarda İYS
                tanımınızın eksik olduğuna dair bir ibare ile karşılaşırsınız.
                150 bin&rsquo;den az kayıtlı m&uuml;şterisi olan kullanıcılar
                i&ccedil;in ID tanımlama s&uuml;reci 15 Temmuz 2021 tarihine
                kadar opsiyoneldir. Sonrasında ise zorunlu hale getirilecektir.
                <p>
                  T&uuml;m bu s&uuml;re&ccedil;lerin y&uuml;r&uuml;t&uuml;lmesi
                  ve sizin adınıza ger&ccedil;ekleştirilen ticari elektronik
                  ileti g&ouml;nderimlerinin aksamadan devam edebilmesi
                  i&ccedil;in Mesaj Üssü hep yanınızdadır. Siz de Mesaj
                  Üssü&rsquo;n&uuml;i iş ortağınız olarak yetkilendirerek,
                  karmaşık s&uuml;re&ccedil;lerin son bulmasını
                  sağlayabilirsiniz. Mesaj Üssü g&ouml;ndereceğiniz iletilerde
                  otomatik kontrol sağlayarak, iletilerinizin İYS formatına
                  uygun olarak aktarılmasında size destek olur. Bu sayede
                  zorlanmadan, kanun ve y&ouml;netmeliklere uygun ticari
                  elektronik ileti g&ouml;nderimlerinizi kolayca
                  ger&ccedil;ekleştirebilirsiniz.
                  <br />
                  <br />
                  İleti Y&ouml;netim Sistemi (İYS) ile ilgili sorularınız olması
                  halinde bizlerle 0 532 532 0000 numaralı hat &uuml;zerinden
                  iletişime ge&ccedil;ebilir, İYS s&uuml;reci ile ilgili merak
                  ettiğiniz detayları &ouml;ğrenebilirsiniz.
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <FooterWithoutAuth />
    </Layout>
  );
};

export default IYSPage;
